import { Record } from 'immutable';

const defaultValues = {
  navDrawerOpen: false,
};

export default class App extends Record(defaultValues, App) {
  constructor(values) {
    super({
      ...values,
    });
  }
}
